document.addEventListener("DOMContentLoaded", () => {
    const SCROLL_THRESHOLD = 100;

    function updateScrollState() {
        document.body.classList.toggle("scrolled-100", window.scrollY > SCROLL_THRESHOLD);
    }

    updateScrollState();
    window.addEventListener("scroll", updateScrollState, { passive: true });

    const header = document.getElementById("site-header");
    const menuToggle = document.getElementById("mobile-menu-toggle");
    const menuPanel = document.getElementById("mobile-menu-panel");
    if (!header || !menuToggle || !menuPanel) return;

    function setMenuOpen(isOpen) {
        header.classList.toggle("menu-open", isOpen);
        menuToggle.setAttribute("aria-expanded", String(isOpen));
        document.body.classList.toggle("overflow-hidden", isOpen);
    }

    menuToggle.addEventListener("click", () => {
        setMenuOpen(!header.classList.contains("menu-open"));
    });

    menuPanel.addEventListener("click", (event) => {
        if (event.target.closest("a, button")) setMenuOpen(false);
    });

    window.addEventListener("resize", () => {
        if (window.innerWidth >= 1024) setMenuOpen(false);
    });
});
